<template>
  <div class="contents header-padding">
    <div class="container">
      <h1>404 Not Found.</h1>
      <p>お探しのページは見つかりませんでした。<br>ページは移動または削除された可能性があります。<br>再度URLをお確かめください。</p>

      <p class="toTop"><a href="/">トップページへ戻る</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsSingle',
  data() {
    return {
      article: null,
    };
  },
  created() {
    const slug = this.$route.params.slug;
    const articles = this.$store.state.news.articles;
    this.article = articles.find((article) => article.slug === slug);
  },
};
</script>


<style scoped lang="scss">
h1 {
  font-size: 1.5em;
  margin-bottom: 2em;
}

p {
  line-height: 2;
}
</style>
